import { merge, omit, set } from "lodash";
import { CLEAR_PAGE_STATE, SET_PAGE_STATE } from "../actions/types";

export default (state = {}, action) => {
    switch (action.type) {
        case SET_PAGE_STATE:
            return { ...state, [action.payload.key]: action.payload.value };

        case CLEAR_PAGE_STATE:
            return omit(state, action.payload);

        default:
            return state;
    }
};
